/** The persistent career (04 §5): the Hall of Honor, and leaving it. */

import { COMPANY } from './content/economy';
import { fullName, isAlive, type ProfileState } from './state';

/** Induct a survivor of the operation just won. Cadet runs induct nobody (04 §10). */
export function induct(profile: ProfileState, rangerId: string): void {
  const op = profile.operation;
  if (!op || op.status !== 'won') throw new Error('Rangers are inducted only after a won operation.');
  if (op.cadet) throw new Error('A Cadet run earns no place in the Hall of Honor.');
  const allowed = COMPANY.inductions[op.difficulty] ?? 1;
  if (op.inducted >= allowed) throw new Error(`This victory allows ${allowed} induction${allowed === 1 ? '' : 's'}.`);
  const ranger = op.company.find((r) => r.id === rangerId);
  if (!ranger || !isAlive(ranger)) throw new Error('Only a surviving ranger of this company can be inducted.');
  if (profile.hall.length >= COMPANY.hallCap) throw new Error('The Hall of Honor is full: retire a veteran first.');
  op.company = op.company.filter((r) => r.id !== rangerId);
  op.inducted += 1;
  profile.hall.push({ ...ranger, veteran: true, status: 'ready', fatigue: 0, recoveryMissions: 0 });
  op.log.push(`${fullName(ranger)} enters the Hall of Honor.`);
}

/** Retire a veteran to the roll of honour: never lost, never used again. */
export function retire(profile: ProfileState, rangerId: string): void {
  const veteran = profile.hall.find((r) => r.id === rangerId);
  if (!veteran) throw new Error('That veteran is not in the Hall of Honor.');
  profile.hall = profile.hall.filter((r) => r.id !== rangerId);
  profile.retired.push({ ...veteran, status: 'retired', pendingPerkChoices: [] });
}
